import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { longDate } from '../../../common/utils';
import { submissionsSelector } from '../../../selectors/submissions';
import SubmissionListItem from '../../../components/submission-list-item/submission-list-item';
import List from '../../../components/list/list';

import styles from './course-detail.scss';
import { clearCurrentSubmission } from '../../../actions/submissions';

const CourseDetailOverview = (props) => {
  const {
    submissions,
  } = props;

  useEffect(() => {
    clearCurrentSubmission();
  }, []);

  return (
    <section className={styles.section}>
      <List>
        {submissions.length === 0 && (
          <h3>This Course currently has no submissions</h3>
        )}
        {submissions.map((item, index) => (
          <SubmissionListItem
            url="submissions"
            id={item.id}
            title={`${item.author.first_name} ${item.author.last_name}`}
            subtitle={longDate(item.created)}
            footer={item.assignment}
            imageURL={item.thumbnail}
            key={item.id}
          />
        ))}
      </List>
    </section>
  );
};

CourseDetailOverview.propTypes = {
  submissions: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  submissions: submissionsSelector(state.submissions.submissions),
  course: state.courses.course,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(CourseDetailOverview);
